import { Stack } from '@mui/material'

import { Maybe } from '@/clients/utoniq-core/schema'
import { ContentFrame } from '@/components/layouts/ContentFrame'
import {
  Props as StoreDeliveryInfoFormProps,
  StoreDeliveryInfoForm,
} from '@/components/pages/StoreDeliveryInfo/template/StoreDeliveryInfoForm'
import { useTranslation } from '@/core'
import { Organism, OrganismFrame } from '@/core/architecture'

import { Header } from './Header'

export type BuyNowDeliveryInfoProps = {
  user: Maybe<StoreDeliveryInfoFormProps['deliveryInfo']>
  onDeliveryInfoSetting: StoreDeliveryInfoFormProps['onSubmitSetting']
  onClose: () => void
}

export const BuyNowDeliveryInfo: Organism<BuyNowDeliveryInfoProps> = ({
  user,
  onDeliveryInfoSetting,
  onClose,
}) => {
  const { t } = useTranslation('storeItemDetail')
  return (
    <OrganismFrame>
      <Header
        back
        title={t('customerInformation', 'お客様情報の入力')}
        onClose={onClose}
      />
      <ContentFrame>
        <Stack sx={{ px: 5, pt: 4 }}>
          <StoreDeliveryInfoForm
            onSubmitSetting={onDeliveryInfoSetting}
            deliveryInfo={user || {}}
            onClose={onClose}
          />
        </Stack>
      </ContentFrame>
    </OrganismFrame>
  )
}
